export default __webpack_public_path__ + "static/media/cover-image.344e72ef.jpg";